import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  BillingAccountMappingWithLinks,
  BillingAccountCreatableFields
} from "../types";

export const createBillingAccount = (
  payload: BillingAccountCreatableFields
) => {
  return apiProxyRequest<BillingAccountMappingWithLinks>(
    `/billing/accounts`,
    "POST",
    payload
  );
};
